import React, { FC } from 'react'
import { Link as RouteLink, useLocation } from 'react-router-dom'
import { routes } from 'config'
import {
  BaseLayout,
  BlankLayout,
  Module,
  ModuleHeader,
  CustomAlert,
  ButtonContainer,
  CustomerSupportNumber,
} from 'components'

const PageNotFound: FC = () => {
  const location = useLocation()

  if (location.pathname === routes.loginCallback) {
    return <BlankLayout />
  }

  return (
    <BaseLayout>
      <Module>
        <ModuleHeader title="Page Not Found!">
          <CustomAlert severity="error">
            Sorry, but we're unable to find the content you are looking for.
            <br />
            Please check the link and try again or call customer support for
            further assistance at <CustomerSupportNumber />
          </CustomAlert>
        </ModuleHeader>
        <ButtonContainer
          secondary={<RouteLink to={routes.login}>Return To Login</RouteLink>}
        />
      </Module>
    </BaseLayout>
  )
}

export default PageNotFound
